<div class="ng-container">
  @if (!showEmptyStateContent) {
    <app-tour-loader />
  } @else {
    <div class="not-found-content" [class.not-found-content_find-tours]="type === 'find-tours'">
      <div class="title">
        <span [innerHTML]="mobileMessages.titleText | template: titleDesktopMapping"></span>
      </div>
      <div class="hint">{{ desktopHintText }}</div>

      @if (isHotelTourList) {
        @if (canOpenCalendar) {
          <button type="button" class="empty-result-calendar-button" (click)="openPriceCalendar($event)">{{ emptyCalendarLabel }}</button>
        }
      } @else if (!loading && hasAvailableDates) {
        <div class="days-list">
          <div *ngFor="let date of desktopAvailableDates" class="day">
              <a [href]="getLink(date.date)" (click)="selectDate($event, date.date)">
                  {{ date.label }} <img src="/x-assets/img/find-form/loupe-blue-thin.svg" alt="">
              </a>
          </div>
        </div>
      }
    </div>
  }
</div>
